/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  cursor: default;
  text-align: left;
  font-size: calc(12rem/14);
  line-height: calc(18rem/14);
}
:host .tag-slot {
  width: 100%;
}
:host ::slotted(davinci-tag) {
  margin: 0 calc(16rem /14) calc(4rem /14) 0;
}

:host([hidden]) {
  display: none;
}`;
export { style };
